'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var assert = require('assert');

var CID = require('cids');

var WantListEntry =
/*#__PURE__*/
function () {
  function WantListEntry(cid, priority) {
    _classCallCheck(this, WantListEntry);

    assert(CID.isCID(cid), 'must be valid CID'); // Keep track of how many requests we have for this key

    this._refCounter = 1;
    this.cid = cid;
    this.priority = priority || 1;
  }

  _createClass(WantListEntry, [{
    key: "inc",
    value: function inc() {
      this._refCounter += 1;
    }
  }, {
    key: "dec",
    value: function dec() {
      this._refCounter = Math.max(0, this._refCounter - 1);
    }
  }, {
    key: "hasRefs",
    value: function hasRefs() {
      return this._refCounter > 0;
    } // So that console.log prints a nice description of this object

  }, {
    key: "equals",
    value: function equals(other) {
      return this._refCounter === other._refCounter && this.cid.equals(other.cid) && this.priority === other.priority;
    }
  }, {
    key: Symbol.toStringTag,
    get: function get() {
      var cidStr = this.cid.toBaseEncodedString();
      return "WantlistEntry <key: ".concat(cidStr, ", priority: ").concat(this.priority, ", refs: ").concat(this._refCounter, ">");
    }
  }]);

  return WantListEntry;
}();

module.exports = WantListEntry;